import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-angular-four-sided',
  templateUrl: './curtain-angular-four-sided.component.html',
  styleUrls: ['./curtain-angular-four-sided.component.scss']
})
export class CurtainAngularFourSidedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
